<div class="m-auto mt-5 col-11">
  <h2 class="mb-4"><span (click)="goBack()" class="clickable"><i class="fa-solid fa-arrow-left"></i></span>
    Newsletter</h2>
  <app-new-mail></app-new-mail>
</div>